import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../src/taskpane/redux";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { InfoPanelMode } from "../../Panels/CMFileInfoPanel";
import { SharePointFolderContentTypeIds } from "../../../src/taskpane/config/constants";
import { menuItemIconStyles } from "../../../src/taskpane/config/controlStyles";
import { Info20Regular } from "../../../src/taskpane/components/_v2/components/SvgIcons/Info20Regular";

export function useMenuItem_Properties(selectedItems: any[], setIsCMFileInfoPanelOpen: (isCMFileInfoPanelOpen: boolean) => void, setInfoPanelMode: (infoPanelMode: InfoPanelMode) => void) {
  const languageStrings = React.useContext(LanguageContext);

  const isBusySaving = useSelector((state: RootState) => state.savingInBackground.isBusySaving);

  const onPropertiesClick = React.useCallback(() => {
    setInfoPanelMode(InfoPanelMode.Update);
    setIsCMFileInfoPanelOpen(true);
  }, [setInfoPanelMode, setIsCMFileInfoPanelOpen]);

  const { menuItem_Properties, menuItem_Properties_IconOnly } = React.useMemo(() => {

    const hasSelection = selectedItems?.length > 0;

    const containsDisallowedItems = hasSelection && selectedItems.some(item =>
      (item.ContentTypeId?.startsWith(SharePointFolderContentTypeIds.folder) && !item.ContentTypeId?.startsWith(SharePointFolderContentTypeIds.documentSet)) ||
      item.EffectiveBasePermissions?.canEditListItem === false
    );

    if (!hasSelection || containsDisallowedItems) {
      return { menuItem_Properties: null, menuItem_Properties_IconOnly: null };
    }

    const commonProps = {
      disabled: isBusySaving === true,
      // iconProps: { iconName: "Info" },
      iconProps: {},
      onRenderIcon: () => <Info20Regular className={menuItemIconStyles} />,
      onClick: onPropertiesClick,
    };

    const menuItem_Properties_IconOnly: IContextualMenuItem = {
      key: "info",
      ...commonProps,
      iconOnly: true,
      tooltipHostProps: {
        content: <span>{languageStrings.Properties}</span>
      },
    };

    const menuItem_Properties: IContextualMenuItem = {
      key: "properties",
      ...commonProps,
      text: languageStrings.Properties,
    };

    return { menuItem_Properties, menuItem_Properties_IconOnly };

  }, [selectedItems, isBusySaving, languageStrings, onPropertiesClick]);

  return {
    menuItem_Properties,
    menuItem_Properties_IconOnly
  }
}